import ajax from '@/api/ajax.js'

/**
 * 登陆 V2
 * @method
 * @return {Object} 返回值 包括code,msg,result
 * @param {Number} type 登录方式 1-手机号 2-邮箱
 * @param {String} account 账号
 * @param {String} password 密码
 */
export const reqLoginV2 = ({ accessToken, type, account, password }) =>
  // ajax('/api/account/loginV2', { accessToken, type, account, password }, 'POST')
  ajax(
    '/api/cxy/account/v2/loginV2',
    { accessToken, type, account, password },
    'POST'
  )
/**
 * 手机快捷登录
 * @param {*} $axios
 * @param {*} phoneNumber 手机号
 * @param {*} phoneAreaCode 区号
 * @param {*} verifyCode 验证码
 */
export const quickLogin = ({ phoneNumber, phoneAreaCode, verifyCode, email }) =>
  ajax(
    '/api/cxy/account/v2/quickLogin',
    {
      phoneNumber,
      phoneAreaCode,
      email,
      verifyCode
    },
    'POST'
  )

/**
 * 查询自己的管理员权限信息
 * @method
 * @return {Object} 返回值 包括code,msg,result
 */
export const getManagerInfo = () =>
  ajax('/api/cxy/account/v2/manager/detail', {}, 'POST')
/**
 * 获取用户信息
 * @method
 * @param {Object} params 内容参数信息
 * @return {Object} 返回值 包括code,msg,result
 */
export const getUserInfo = () =>
  ajax('/api/cxy/v2/user/getInfo', { version: 1 }, 'POST')

// 扫码登录
export const qrLogin = () => ajax('/api/cxy/account/v2/qrLogin', {}, 'POST')

/**
 * 查询扫码状态
 * @param {identical} 二维码秘钥
 */
export const qrQuery = identical =>
  ajax('/api/cxy/account/v2/qrQuery', { identical }, 'POST')

/**
 * 飞书登录
 * @param {String} code 飞书授权码
 */
export const feishuLoginApi = code =>
  ajax('/api/cxy/account/v2/feishuLogin', { code }, 'POST')
